import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector, {
  DetectorOptions,
} from "i18next-browser-languagedetector";

declare global {
  interface Window {
    IBPeventCreator: Function;
    IBPconstants: {};
    functionMap: Function;
    functionMapModify: Function;
    functionMapCopy: Function;
  }
}

const languageDetectorOptions: DetectorOptions = {
  order: ["localStorage", "cookie", "navigator"],
  lookupCookie: "LANGUAGE",
  lookupLocalStorage: "LANGUAGE",
  caches: ["localStorage", "cookie"],
};

const eventCreator = (eventName: string, detail: {}): void => {
  const customEevent = new CustomEvent(eventName, {
    detail,
  });

  window.dispatchEvent(customEevent);
};

window.IBPeventCreator = eventCreator;

const i18n = createInstance({
  fallbackLng: process.env.REACT_APP_DEFAULT_LANG,
  debug: process.env.REACT_APP_DEBUG === "1",
  interpolation: {
    escapeValue: false,
  },
  resources: {},
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: languageDetectorOptions,
    lng:
      localStorage.getItem("LANGUAGE") ||
      process.env.REACT_APP_DEFAULT_LANG ||
      "en",
  });

export default i18n;
